import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";

// Define error types
export type AuthErrorType =
  | "existing-user-github"
  | "no-account"
  | null;

  type ErrorMessages = {
  [key in Exclude<AuthErrorType, null>]: string;
};

const errorMessages: ErrorMessages = {
  "existing-user-github": "You have an existing Github account, please continue using Github.",
  "no-account": "You don't have an existing account, please create an account using Google"
};

export interface IOnboardingContext {
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  authError: AuthErrorType;
  setAuthError: Dispatch<SetStateAction<AuthErrorType>>;
  getErrorMessage: (errorType: AuthErrorType) => string | null;
}

const OnboardingContext = createContext<IOnboardingContext | null>(null);

export const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error(
      "useOnboardingContext must be used within an OnboardingProvider"
    );
  }
  return context;
};

export const OnboardingProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState<AuthErrorType>(null);

  const getErrorMessage = (errorType: AuthErrorType) => {
    if (!errorType) return null;
    return errorMessages[errorType];
  };

  const context = {
    loading,
    setLoading,
    authError,
    setAuthError,
    getErrorMessage,
  };

  return (
    <OnboardingContext.Provider value={context}>
      {children}
    </OnboardingContext.Provider>
  );
};
